import { Scales01Icon } from '@langchain/untitled-ui-icons';

import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';
import { useRunRules } from '@/hooks/useSwr';

export function EvaluatorDetailsCrumb(props: Partial<BreadcrumbData>) {
  const { evaluatorId } = useParams();
  const { data: rules } = useRunRules({
    id: evaluatorId ? [evaluatorId] : undefined,
  });

  const evaluator = rules?.find((r) => r.id === evaluatorId);

  const evaluatorName = evaluator?.display_name || 'Evaluator';

  return (
    <Breadcrumb
      icon={<Scales01Icon className="h-4 w-4" />}
      name={evaluatorName}
      {...props}
    />
  );
}
